import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Stack,
  Paper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SendIcon from "@mui/icons-material/Send";
// import { Controller } from "react-hook-form";
import CustomInput from "../../../../Components/CustomInput";

import BoxInput from "../../../../Components/BoxInput";
import StyledInput from "../../../../Components/ContactInput";
import { contactForm } from '../../../../api/services';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';



const schema: yup.ObjectSchema<Omit<LeadData, 'type'>> = yup.object({
  name: yup.string().required('Name is required'),
  email: yup
    .string()
    .email('Invalid email format')
    .required('Email is required'),
  phoneNumber: yup
    .string()
    .matches(
      /^[6-9]\d{9}$/,
      'Phone number must start with 6, 7, 8, or 9 and be 10 digits',
    )
    .required('Phone number is required'),
  message: yup.string().optional(),
});
interface LeadData {
  name: string;
  email: string;
  phoneNumber: string;
  message?: string;
  type?: string;
}


const ContactSection: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<LeadData>({
    resolver: yupResolver(schema),
  });

  const mutation = useMutation({
    mutationFn: (newFormData: LeadData) => contactForm(newFormData),
    onSuccess: () => {
      toast.success('Successfully submitted!');
      resetForm();
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || 'Submission failed');
    },
  });
  const resetForm = () => {
    reset({
      name: '',
      email: '',
      phoneNumber: '',
      message: '',
    });
  };

  const onSubmit = (data: LeadData) => {
    mutation.mutate({ ...data, type: 'coaching' });
  };

  return (
    <Box
      sx={{
        py: 8,
        position: "relative",
        overflow: "hidden",
        // backgroundColor: "#ffffff",
        // background: `
        //   radial-gradient(circle at 20% 20%, rgba(15,99,165,0.35), transparent 40%),
        //   radial-gradient(circle at 80% 80%, rgba(15,99,165,0.25), transparent 40%),
        //   linear-gradient(135deg, #071a2d 0%, #0b2a45 100%)
        // `,
        // color: "white",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,   // ✅ moved to left
          width: {xs:'100%',lg:'77%'},
          height: "100%",
          background: "linear-gradient(135deg, #0f63a5, #0c4e82)",
          clipPath: "polygon(0% 0%, 80% 0%, 100% 100%, 0% 100%)",
          zIndex: 0,
        },

        // "&::before": {
        //   content: '""',
        //   position: "absolute",
        //   top: 0,
        //   right: 0,
        //   width: "45%",
        //   height: "100%",
        //   background: "linear-gradient(135deg, #0f63a5, #0c4e82)",
        //   clipPath: "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)",
        //   zIndex: 0,
        // },
            "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          right: 0,
          width: "45%",
          height: "100%",
          backdropFilter: "blur(40px)",
        }

      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        {/* HEADER */}
        <Box textAlign="center" mb={10}>
          <Typography
            variant="h3"
            fontWeight={800}
            gutterBottom
            sx={{ color: "white" }}
          >
            Ready to Build a Predictable <span style={{color:'black'}}>Sales Engine?</span>
          </Typography>

          {/* <Typography
            sx={{
              color: "#fff",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Book Your Complimentary Strategy Call
          </Typography>

          <Typography sx={{ opacity: 0.8,color: "#000", }}>
            Let’s evaluate where your sales system stands and identify exactly what’s slowing your growth.
          </Typography>
          <Typography sx={{ opacity: 0.8 ,color: "#fff",}}>
            This is a focused, high-value discussion, not a sales pitch.
          </Typography> */}
        </Box>

        <Grid container spacing={8}>
          {/* LEFT SIDE */}
          <Grid item xs={12} md={6}>
            <Typography variant="h4" fontWeight={700} mb={3}
              sx={{ textAlign: "start",color:'white' }}>

              Get In Touch
            </Typography>

            <Typography sx={{ opacity: 0.8, textAlign: "start" ,color:'white' }} mb={1}  >
              Serious about scaling your sales performance?
            </Typography>
            <Typography sx={{ opacity: 0.8, textAlign: "start" ,color:'white' }} mb={5}  >
              Schedule a complimentary strategy session and discover how structured sales architecture can transform your results, whether you're an individual closer or leading an organization.

            </Typography>

            <Stack spacing={2} mb={4}>
              {[
                {
                  icon: <PhoneIcon />,
                  label: "Phone",
                  value: "+91 988 542 0885",
                  link: "tel:+919885420885"
                },
                {
                  icon: <EmailIcon />,
                  label: "Email",
                  value: "connect@rajivwilliams.com",
                  link: "mailto:connect@rajivwilliams.com"
                },
                {
                  icon: <LocationOnIcon />,
                  label: "Location",
                  value: "Hyderabad, India"
                },
              ].map((item, index) => (
                <Stack direction="row" spacing={2} alignItems="center" key={index}>
                  <Box
                    sx={{
                      background: "rgba(255,255,255,0.08)",
                      p: 2,
                      borderRadius: "14px",
                      border: "1px solid rgba(255,255,255,0.15)",
                    }}
                  >
                    {React.cloneElement(item.icon, {
                      sx: { color: "#fff" },
                    })}
                  </Box>

                  <Box>
                    <Typography fontWeight={600} sx={{ textAlign: "start" ,color:'white' }}>
                      {item.label}
                    </Typography>

                    {item.link ? (
                      <Typography
                        component="a"
                        href={item.link}
                        sx={{
                          opacity: 0.7,
                          textAlign: "start",
                          textDecoration: "none",
                          color: "inherit",
                          "&:hover": { color: "#000" },
                        }}
                      >
                        {item.value}
                      </Typography>
                    ) : (
                      <Typography sx={{ opacity: 0.7, textAlign: "start" ,color:"white"}}>
                        {item.value}
                      </Typography>
                    )}
                  </Box>
                </Stack>
              ))}
            </Stack>


            {/* STATS */}
            {/* <Stack direction="row" spacing={3}>
              {[
                { value: "500+", label: "Professionals Coached" },
                { value: "15+", label: "Years of High-Ticket Sales Experience" },
              ].map((stat, i) => (
                <Paper
                  key={i}
                  sx={{
                    flex: 1,
                    p: 3,
                    textAlign: "center",
                    borderRadius: "16px",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Typography
                    variant="h5"
                    fontWeight={800}
                    sx={{ color: "#fff" }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography fontSize={13} sx={{ opacity: 0.7 ,color:'white' }}>
                    {stat.label}
                  </Typography>
                </Paper>
              ))}
            </Stack> */}
          </Grid>

          {/* RIGHT SIDE FORM */}
          <Grid item xs={12} md={6}>
            <Paper
             component="form" onSubmit={handleSubmit(onSubmit)}
              sx={{
                p: 6,
                borderRadius: "24px",
                background: "#124e7847",
                border: "1px solid rgba(255,255,255,0.2)",
                backdropFilter: "blur(20px)",
                boxShadow: "0 30px 80px rgba(0,0,0,0.4)",
              }}
            >
              <Stack spacing={2}>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <>
                      {/* <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          mb: 1,
                          color: "#333",
                        }}
                      >
                        Full Name
                      </Typography> */}

                      <BoxInput
                        placeholder="Enter your full name"
                        {...field}   // ✅ VERY IMPORTANT
                        error={!!errors.name}
                        helperText={errors.name?.message}
                      />
                    </>
                  )}
                />

                <Grid item xs={12}>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <BoxInput
                        placeholder="Enter your Email"
                        {...field}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field }) => (
                      <BoxInput
                        placeholder="Enter your Phone Number"
                        {...field}
                        error={!!errors.phoneNumber}
                        helperText={errors.phoneNumber?.message}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    name="message"
                    control={control}
                    render={({ field }) => (
                      <BoxInput

                        placeholder="Write your message here..."
                        multiline
                        rows={3}
                        {...field}

                      />
                    )}
                  />
                </Grid>

                <Button
                  type="submit"
                  variant="contained"
                  endIcon={<SendIcon />}
                  sx={{
                    py: 1.6,
                    fontWeight: 700,
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #0f63a5, #0c4e82)",
                    boxShadow:
                      "0 15px 40px rgba(15,99,165,0.35)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #0c4e82, #083b63)",
                    },
                  }}
                >
                  Send Message
                </Button>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactSection;
